import script from "./ScrollTopProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTopProgress.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTopProgress.vue?vue&type=style&index=0&id=9076806e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9076806e"]])

export default __exports__